// 🔒
import { useLayoutEffect } from "react";
import { useLocation } from "react-router";

export default function ScrollToHash() {
  const location = useLocation();

  useLayoutEffect(() => {
    if (location.pathname === "/") {
      return;
    }

    if (location.hash) {
      const id = location.hash.slice(1);

      const timeout = window.setTimeout(() => {
        const element = document.getElementById(id);
        if (!element) return;

        const navbar = document.querySelector(".navbar");
        const navbarHeight = navbar ? navbar.offsetHeight : 0;
        const offset = 16;

        const top =
          element.getBoundingClientRect().top +
          window.scrollY -
          navbarHeight -
          offset;

        window.scrollTo({
          top,
          behavior: "smooth",
        });
      }, 80);

      return () => window.clearTimeout(timeout);
    }

    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, [location.pathname, location.hash]);

  return null;
}
// 🔒